const resumeAction = {
  TOGGLE_DIALOG: "@resumeReducer/TOGGLE_DIALOG",
  SET_TYPE :"@resumeReducer/SET_TYPE",
};

export default resumeAction;
